import { FilterListOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import { graphql, type DocumentType } from '@/gql';

import { PostEditTopicsDialog } from './edit-topics-menu-item/PostEditTopicsDialog';

const POST_EDIT_TOPICS_MENU_ITEM_POST_FRAGMENT = graphql(`
  fragment postEditTopicsMenuItemPostFragment on Post {
    ...postEditTopicsDialogPostFragment
  }
`);

const POST_EDIT_TOPICS_MENU_ITEM_GROUP_FRAGMENT = graphql(`
  fragment postEditTopicsMenuItemGroupFragment on Group {
    ...postEditTopicsDialogGroupFragment
  }
`);

interface Props {
  post: DocumentType<typeof POST_EDIT_TOPICS_MENU_ITEM_POST_FRAGMENT>;
  group: DocumentType<typeof POST_EDIT_TOPICS_MENU_ITEM_GROUP_FRAGMENT>;
  onClose: () => void;
}

export const PostEditTopicsMenuItem = ({ post, group, onClose }: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <MenuItem
        onClick={() => {
          onClose();
          setDialogOpen(true);
        }}
        data-tour-id="post-modify-topic-button"
      >
        <ListItemIcon>
          <FilterListOutlined />
        </ListItemIcon>
        <ListItemText primary="Add/remove topic..." />
      </MenuItem>
      <PostEditTopicsDialog
        post={post}
        group={group}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
